export default __webpack_public_path__ + "locales/si/UploadPanel.json?hash=29944163b93f8a5910a7d32985a3353e";